import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrl: './thanks.component.css'
})
export class ThanksComponent implements OnInit {
  ngOnInit(): void {
    setTimeout(() => {
      window.close();
    }, 5000); // 5 seconds
  }
}
